<style scoped lang="scss">
    .assistance-toggle-label {
        font-size: 1.4em;
        display: flex;
        .checkbox-container {
            width: 30px;
        }
        span {
            /*margin-left: 8px;*/

        }

        input[type=checkbox] {
            transform: scale(1.4);
        }
    }
</style>
<template>
    <div v-if="application" class="uk-form">


        <div class="uk-grid">
            <div class="uk-width-1-1 uk-margin-large-top" v-if="programSettings['uses-duplicative-assistance']">
                <fieldset class="uk-margin-large-bottom">
                  <h3>Have you received assistance through any other programs?</h3>
                  <div>
                    <label> <input type="radio" class="uk-radio" :value="1" v-model="application.receiving_other_assistance"> Yes</label>
                  </div>

                  <div>
                    <label> <input type="radio" class="uk-radio" :value="0" v-model="application.receiving_other_assistance"> No</label>
                  </div>

                </fieldset>
            </div>

            <div v-if="application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false" class="uk-width-1-1 uk-margin-large-bottom">
                <div class="uk-width-1-1">
                    <h2>Rental Information</h2>
                    <label class="assistance-toggle-label">
                        <div class="checkbox-container">
                            <input type="checkbox" v-model="application.renter" class="uk-checkbox">
                        </div>
                        <div>
                            <span>I am a Renter</span>
                        </div>
                    </label>
                </div>

                <div class="uk-width-1-1 uk-margin-top">
                    <div class="uk-grid">
                        <div class="uk-width-small-1-1 uk-width-medium-2-3" style="margin-left: 25px; padding-right: 25px;">
                            <validated-section :errors="errors" field="renterManager">
                                <property-contact-form
                                        table="household_applications"
                                        :application-role-id="3"
                                        @beforeSubmit="save"
                                        :allowChange="allowPropertyContactChange"
                                        :person="renterManager"></property-contact-form>
                            </validated-section>
                            <hr class="uk-width-1-1 uk-margin-top uk-margin-bottom">
                            <label for="related_to_landlord"> <input type="checkbox" v-model="application.related_to_landlord"> Check this box if you or someone in your household is related to or an employee of the landlord.</label>
                            <hr class="uk-width-1-1 uk-margin-top uk-margin-bottom">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false" class="uk-width-1-1 uk-margin-large-bottom" v-for="type in assets.unitLedgerEntryTypes">
                <ledger-entries-for-type
                        @updated="updateLedgerValues(type, $event)"
                        :ref="'assistance_'+type.id"
                        :show-disconnect="type.is_utility"
                        :type="type">

                    <!-- Home Owner Fields -->
                    <div v-if="type.name === 'Mortgage'">

                        <fieldset data-uk-margin>
                            <legend>The Property Has (check all that apply)</legend>
                            <div class="uk-grid uk-margin-bottom">
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <validated-section :errors="errors" field="owner_liens">
                                        <label>
                                            <input type="checkbox" v-model="owner.liens.first"/>
                                            A First Lien
                                        </label>
                                    </validated-section>
                                </div>
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <label>
                                        <input type="checkbox" v-model="owner.liens.second"/>
                                        A Second Lien
                                    </label>
                                </div>
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <label>
                                        <input type="checkbox" v-model="owner.liens.additional"/>
                                        Additional Subordinate Lien(s)
                                    </label>
                                </div>
                            </div>
                            <hr class="uk-grid-divider">

                            <legend>My property taxes and insurance</legend>
                            <div class="uk-grid uk-margin-bottom">
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <validated-section :errors="errors" field="escrowed">
                                        <label><input type="radio" v-model="owner.escrowed" :value="0" class=""> Both my taxes and insurance
                                            are escrowed.</label>
                                    </validated-section>

                                </div>
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <label><input type="radio" v-model="owner.escrowed" :value="1"
                                                  onClick="UIkit.modal.alert('Attention! You will need to provide proof that your taxes and insurance are not delinquent.');">
                                        Neither my taxes or my insurance are escrowed.</label>
                                </div>
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <label><input type="radio" v-model="owner.escrowed" :value="2"
                                                  onClick="UIkit.modal.alert('Attention! You will need to provide proof that your insurance is not delinquent.')">
                                        My taxes are escrowed, but not my insurance.</label>
                                </div>
                                <div class="uk-width-medium-1-4 uk-margin-bottom">
                                    <label><input type="radio" v-model="owner.escrowed" :value="3"
                                                  onClick="UIkit.modal.alert('Attention! You will need to provide proof that your taxes are not delinquent.')">
                                        My insurance is escrowed, but not my taxes.</label>
                                </div>

                            </div>
                            <hr class="uk-grid-divider">

                            <legend>I have homeowners association (HOA) fees</legend>
                            <div class="uk-grid uk-margin-bottom">
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <validated-section :errors="errors" field="hoa">
                                        <label><input type="radio" v-model="owner.hoa" :value="0"> I do not have HOA fees.</label>
                                    </validated-section>
                                </div>
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <label><input type="radio" v-model="owner.hoa" :value="1"> Yes, and they are current (all HOA dues have
                                        been paid to date).</label>
                                </div>
                                <div class="uk-width-medium-1-3 uk-margin-bottom">
                                    <label><input type="radio" v-model="owner.hoa" :value="2"
                                                  onClick="UIkit.modal.alert('Attention! Your HOA fees must be current to be eligible for the program.');">
                                        Yes, and they are NOT current (I am behind on my HOA dues).</label>
                                </div>


                            </div>
                            <hr class="uk-grid-divider">

                            <legend class="">First Mortgage Information</legend>

                            <div class="uk-container ">
                                <div class="uk-grid">
                                    <div class="uk-width-medium-5-10 ">
                                        <validated-section :errors="errors" field="mortgageServiceProvider">
                                            <input type="text" placeholder="First Mortgage Servicer Name"
                                                   v-model="application.mortgage_servicer"
                                                   class="uk-width-1-1 uk-margin-bottom uk-form-large">
                                        </validated-section>

                                    </div>
                                    <div class="uk-width-medium-5-10 ">
                                        <validated-section :errors="errors" field="mortgageAccountNumber">
                                            <input type="text" placeholder="Account Number"
                                                   v-model="owner.mortgageAccountNumber"
                                                   class="uk-width-1-1 uk-margin-bottom uk-form-large">
                                        </validated-section>

                                    </div>
                                </div>
                                <div class="uk-grid">

                                    <div class="uk-width-medium-1-2 uk-margin-bottom">
                                        <label><input type="radio" v-model="owner.mortgageCurrent" @change="onCurrentMortgageChanged" :value="true">
                                            I am <strong>CURRENT</strong> on
                                            this mortgage.
                                        </label>
                                    </div>
                                    <div class="uk-width-medium-1-2 uk-margin-bottom">
                                        <label><input type="radio" v-model="owner.mortgageCurrent" :value="false"> I am <strong>BEHIND</strong> on this mortgage.</label>

                                    </div>

                                    <div class="uk-width-medium-5-10 ">
                                        <validated-section :errors="errors" field="unpaidPrincipalAmount">
                                            <vue-numeric currency="$" v-model="owner.unpaidPrincipalAmount" v-show="owner.mortgageCurrent" type="text"
                                                         placeholder="Unpaid Principal Balance"
                                                         class="uk-width-1-1 uk-margin-bottom uk-form-large" />
                                        </validated-section>
                                    </div>
                                    <div class="uk-width-medium-5-10 ">
                                        <validated-section :errors="errors" field="delinquentAmount">
                                            <vue-numeric currency="$" v-model="owner.delinquentAmount" v-show="!owner.mortgageCurrent" type="text"
                                                         placeholder="Amount Delinquent"
                                                         class="uk-width-1-1 uk-margin-bottom uk-form-large" />
                                        </validated-section>
                                    </div>
                                </div>


                                <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;">
                            </div>

                        </fieldset>
                    </div>

                    <div class="uk-width-1-1" v-if="type.name === 'Rent'">


                        <div class="uk-grid">

                            <div class="uk-width-1-1 uk-width-medium-1-1" v-if="programSettings['uses-bedroom-count-field']">
                                <label class="">How Many Bedrooms Do You Have?</label><br/>
                                <validated-section :errors="errors" field="bedroom_count">
                                    <select v-model="application.bedroom_count" class="uk-select uk-width-1-1 uk-form-large" style="width: 100%;">
                                        <option :value="null"></option>
                                        <option :value="0">Efficiency</option>
                                        <option :value="1">One Bedroom</option>
                                        <option :value="2">Two Bedrooms</option>
                                        <option :value="3">Three Bedrooms</option>
                                        <option :value="4">Four or More Bedrooms</option>
                                    </select>
                                </validated-section>
                            </div>

                            <div class="uk-width-1-1 uk-width-medium-1-1" v-if="programSettings['uses-bedroom-count-field']">
                                <label class="">How Much Do You Pay For Rent Before Fees?</label><br/>
                                <validated-section :errors="errors" field="rent_amount">
                                    <input type="number" v-model="application.rent_amount" class="uk-form-large uk-width-1-1">
                                </validated-section>
                            </div>

                            <div class="uk-width-1-1 uk-margin-bottom" v-if="permissions.processor && application.fmr_amount">
                                <h3> FMR Amount: {{ application.fmr_amount | formatMoney}}</h3>
                            </div>

                            <div class="uk-width-1-1 uk-width-medium-1-1">
                                <label class="">My Eviction Status:</label><br/>
                                <validated-section :errors="errors" field="applicant_eviction_status_id">
                                    <select v-model="application.applicant_eviction_status_id" class="uk-select uk-form-large" style="width: 100%;">
                                        <option :value="0"></option>
                                        <option :value="1">I Have Received a 3 Day Notice</option>
                                        <option :value="2">I Have Received a Court Date Notice</option>
                                        <option :value="3">I Am Not Delinquent, But I am Struggling to Pay Rent</option>
                                        <option :value="4">I Am Delinquent But I Have Not Received an Eviction Notice</option>
                                    </select>
                                </validated-section>
                            </div>
                        </div>
                        <div class="uk-grid">
                            <div class="uk-width-small-1-1 uk-width-medium-1-1" style="padding-bottom: 15px;">
                                <!--<label>Have You Received an Adjusted Monthly Income (AMI) Subsidy? </label>-->
                                <label>Do you receive a federal subsidy for rental assistance that can be adjusted due to changes in your income? </label>
                                <div class="uk-grid uk-margin-top">
                                    <div class="uk-width-1-4">
                                        <label>
                                            <input type="radio" :value="1" v-model="received_ami_subsidy"> Yes
                                        </label>
                                    </div>
                                    <div class="uk-width-1-4">
                                        <label>
                                            <input type="radio" :value="0" v-model="received_ami_subsidy"> No
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="uk-width-small-1-1 uk-width-medium-1-1" v-if="received_ami_subsidy">
                                <label>Has your rent been adjusted to your current income? </label>
                                <div class="uk-grid uk-margin-top">
                                    <div class="uk-width-1-4">
                                        <label>
                                            <input type="radio" :value="1" v-model="ami_subsidy_adjusted"> Yes
                                        </label>
                                    </div>
                                    <div class="uk-width-1-4">
                                        <label>
                                            <input type="radio" :value="0" v-model="ami_subsidy_adjusted" onClick="UIkit.modal.alert('You will need to speak with your property manager and have them adjust your rents based on your current income prior to requesting rental assistance. You can move forward with requesting utility and/or internet assistance.  However, please note that once the utility/internet assistance is received, you must wait 90 days to apply for more assistance (including rental assistance). To avoid this delay, you may want to wait until your rent adjustment has been made so you can apply for all assistance at the same time. Be sure to get a copy from your Manager that shows what your rents have been adjusted to and when the new rents take effect.');"> No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="uk-grid">
                            <div class="uk-width-1-1 uk-width-medium-1-2" v-if="received_ami_subsidy == 1 && ami_subsidy_adjusted == 1">
                                <label class="">Which federal program gives you the assistance?</label><br/>
                                <validated-section :errors="errors" field="applicant_eviction_status_id">
                                    <select v-model="application.federal_program_assistance_id" class="uk-select uk-form-large" style="width: 100%;">
                                        <option :value="0"></option>
                                        <option :value="1">Section 8 – Project Based</option>
                                        <option :value="2">Section 8 – Housing Choice Voucher</option>
                                        <option :value="3">HUD – Project Based Vouchers</option>
                                        <option :value="4">USDA – Rural Development</option>
                                        <option :value="5">Other</option>
                                    </select>
                                </validated-section>
                            </div>

                            <div class="uk-width-1-1 uk-width-medium-1-2" v-if="application.federal_program_assistance_id == 5 && ami_subsidy_adjusted == 1">
                                <label>Please enter the name of the federal program gives you the assistance.</label>
                                <input type="text" placeholder="Federal Program Name"
                                       v-model="application.federal_program_assistance_other"
                                       class="uk-width-1-1 uk-margin-bottom uk-form-large">
                            </div>

                            <div class="uk-width-small-1-1 uk-margin-top uk-alert-danger" style="padding: 8px;" v-if="application.ami_subsidy_adjusted === 0 && application.program.settings['ami-blocks-rent-entries']">
                                Warning: In order to apply for rental assistance, your AMI must be adjusted to your current income.
                            </div>
                        </div>
                        <div class="uk-grid" v-if="received_ami_subsidy == 1 && ami_subsidy_adjusted == 1 && programSettings['requires-interim-certification']">
                            <div class="uk-width-small-1-1 uk-width-medium-2-3">
                                <FileUploadDropzone
                                    uploadUrl="api/hope/documents"
                                    title="Interim Certification, or Document showing Rent Adjustment to Current Income"
                                    :documents="uploads"
                                    :member="applicant"
                                    fileType="assistance-rent"
                                    @fileAdded="fileAdded"
                                    @fileDeleted="fileDeleted"
                                    ref="dropzoneUpload"
                                ></FileUploadDropzone>
                                <validated-section :errors="errors" field="renterDocs">
                                </validated-section>
                            </div>
                        </div>
                    </div>

                </ledger-entries-for-type>
            </div>
        </div>

        <div v-if="application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false" class="uk-margin-large-top">
            <h2 class="uk-text-right">Total Assistance Requested: {{ totalRequested | formatMoney }}</h2>
            <h2 v-if="permissions.processor" class="uk-text-right">Total Assistance Approved: {{ totalApproved | formatMoney }}</h2>
            <h2 v-if="permissions.processor" class="uk-text-right">Total Assistance Paid: {{ totalPaid | formatMoney }}</h2>
        </div>

    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import PropertyContactForm from "../../../../../components/AppWizard/Step2/PropertyContactForm";
    import LedgerEntriesForType from "../../../../../components/AppWizard/Step2/LedgerEntriesForType";
    import EventBus from "../../../../../../dashboard/EventBus";
    import FileUploadDropzone from "../../../../../../components/FileUploadDropzone";

    export default {
        name: "Step2",
        components: {LedgerEntriesForType, PropertyContactForm, ValidatedSection, FileUploadDropzone},
        data() {
            return {
                errors: {},
                uploads: [],
                eviction: false,
                evictionDeposit: 0,
                evictionRent: 0,
                evictionNewName: '',
                evictionContactPhone: '',
                evictionContactEmail: '',
                totalRequested: 0,
                totalApproved: 0,
                totalPaid: 0,

                owner: {
                    liens: {
                        first: false,
                        second: false,
                        additional: false,
                    },
                    escrowed: null,
                    hoa: null,
                    mortgageServiceProvider: '',
                    mortgageAccountNumber: '',
                    mortgageCurrent: true,
                    unpaidPrincipalAmount: 0,
                    delinquentAmount: 0,
                },
                allowPropertyContactChange: true,
            }
        },
        computed: {
            received_ami_subsidy: {
                get() {
                    return this.application.received_ami_subsidy;
                },
                set(value) {
                    this.$store.commit('Application/setApplicationField', {field: 'received_ami_subsidy', value: value})
                },
            },
            ami_subsidy_adjusted: {
                get() {
                    return this.application.ami_subsidy_adjusted;
                },
                set(value) {
                    this.$store.commit('Application/setApplicationField', {field: 'ami_subsidy_adjusted', value: value})
                },
            },
            ...mapState('App', {
                permissions: state => state.permissions,
            }),
            ...mapState('Application', {
                assets: state => state.assets,
                application: state => state.application,
                documents: state => state.documents,
                applicant: state => state.applicant,
                renterOwner: state => state.renterOwner,
                renterManager: state => state.renterManager,
                organization: state => state.organization,
                household: state => state.household,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
        },
        watch: {
            application(newValue) {
                this.initData();
            },
            ami_subsidy_adjusted(newValue) {
                if(newValue === 0 && this.application.program.settings['ami-blocks-rent-entries']) {
                    // Remove rental assistance records
                    this.$refs.assistance_1[0].clearAssistance();
                }else {
                    this.$refs.assistance_1[0].setDataFromEntries();
                }
                this.totalRequested = this.getTotalRequested();
            },
            'owner.liens.second': (newValue) => {
                if(newValue == true) {
                    UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
                }
            },
            'owner.liens.additional': (newValue) => {
                if(newValue == true) {
                    UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
                }
            },

        },
        mounted() {
            if(this.application) {
                this.initData();
            }

            if(!this.programSettings['hide-assistance-without-funding-response']) {
                this.application.receiving_other_assistance = 0;
            }
        },
        methods: {
            fileAdded(docs) {
                this.uploads = this.uploads.concat(docs)

            },

            fileDeleted(index) {
                this.uploads.splice(index, 1)
            },

            updateLedgerValues(type, payload) {
                if (payload)
                {   
                    this.allowPropertyContactChange = !Object.values(payload).find( item => item.has_payment );
                } else {
                    this.allowPropertyContactChange = true
                }

                this.totalRequested = this.getTotalRequested();
                this.totalApproved = this.getTotalApproved();
                this.totalPaid = this.getTotalPaid();
                this.$forceUpdate();
            },


            initData() {
                this.owner.liens.first = this.application.has_first_lien == 1;
                this.owner.liens.second = this.application.has_second_lien == 1;
                this.owner.liens.additional = this.application.has_additional_lien == 1;
                this.owner.mortgageCurrent = this.application.mortgage_current == 1;
                this.owner.unpaidPrincipalAmount = this.application.mortgage_unpaid_principal_amount === null ? 0 : parseFloat(this.application.mortgage_unpaid_principal_amount);
                this.owner.delinquentAmount = this.application.mortgage_delinquent_amount === null ? 0 : parseFloat(this.application.mortgage_delinquent_amount);
                this.owner.escrowed = this.application.escrow_value;
                this.owner.hoa = this.application.hoa_value;
                this.owner.mortgageServiceProvider = this.application.mortgage_servicer ? this.application.mortgage_servicer : '';
                this.owner.mortgageAccountNumber = this.application.mortgage_account_number ? this.application.mortgage_account_number : '';
                this.mortgageAmount = parseFloat(this.application.requested_mortgage_amount);

                this.eviction = this.application.is_eviction == 1;
                this.evictionDeposit = this.application.eviction_deposit ? this.application.eviction_deposit : 0;
                this.evictionRent = this.application.eviction_rent ? this.application.eviction_rent : 0;
                this.evictionNewName = this.application.eviction_name ? this.application.eviction_name : '';
                this.evictionContactPhone = this.application.eviction_phone ? this.application.eviction_phone : '';
                this.evictionContactEmail = this.application.eviction_email ? this.application.eviction_email : '';

                this.totalRequested = this.getTotalRequested();

                this.uploads = this.documents.filter(item => item.file_type === 'assistance-rent')
            },

            isSequential(array) {
               let length = array.length;
               if(length === 1) return true;
               let first = array.shift();
               let last = array.pop();
               let diff = last.diff(first, 'months');
               return diff === length-1;
            },
            validateConsecutive(values, maxConsecutive) {
                let months = [];
                _.each(values, (amounts, key) => {
                    if(amounts.due > 0 || amounts.fees > 0 || amounts.paid > 0) {
                        months.push(moment(key+'-15'));
                    }
                })


                if(months.length > maxConsecutive) {
                    return false;
                }

                // make sure months are consecutive
                let sequential = this.isSequential(months);

                if(!sequential) return false;

                return true;
            },
            async validateStep() {
                this.errors = {};

                if(this.application.home_owner) {

                    if(this.owner.liens.first === false && this.owner.liens.first === false && this.owner.liens.first === false) {
                        this.errors['owner_liens'] = { errors: ['You must select at least one lien option.']};
                    }

                    if(this.owner.escrowed === null) {
                        this.errors['escrowed'] = { errors: ['You must make a taxes and insurance selection.']}
                    }

                    if(this.owner.hoa === null) {
                        this.errors['hoa'] = { errors: ['You must make a HOA selection.']}
                    }

                    if(this.owner.mortgageCurrent === true && (this.owner.unpaidPrincipalAmount === 0 || this.owner.unpaidPrincipalAmount === null)) {
                        this.errors['unpaidPrincipalAmount'] = { errors: ['You must enter an amount.']}
                    }

                    if(this.owner.mortgageCurrent === false && (this.owner.delinquentAmount === 0 || this.owner.delinquentAmount === null)) {
                        this.errors['delinquentAmount'] = { errors: ['You must enter an amount.']}
                    }

                    if(this.owner.mortgageAccountNumber === null || this.owner.mortgageAccountNumber === '') {
                        this.errors['mortgageAccountNumber'] = { errors: ['Mortgage Account Number is required.']}
                    }

                    if(this.application.mortgage_servicer === null || this.application.mortgage_servicer === '') {
                        this.errors['mortgageServiceProvider'] = { errors: ['Mortgage Servicer Name is required.']}
                    }
                }

                if(this.application.renter) {
                    // Needs property owner and manager


                    if(!this.renterManager || !this.renterManager.company_name) {
                        this.errors.renterManager = { errors: ['You must have a property manager selected.']}
                    }
                }

                if(this.needRentAssistance) {
                    if(this.application.applicant_eviction_status_id === null) {
                        this.errors['applicant_eviction_status_id'] = { errors: ['This field is required.'] };
                    }

                    if(this.application.bedroom_count == 1) {
                        this.errors['applicant_eviction_status_id'] = { errors: ['This field is required.'] };
                    }

                    if(this.application.program.consecutive_month_constraint !== null && this.application.program.consecutive_month_constraint !== 0) {
                        if(!this.validateConsecutive(this.rent.monthInputs, this.application.program.consecutive_month_constraint)) {
                            this.errors['rent_months'] = { errors: ['You can only select up to ' + this.application.program.consecutive_month_constraint + ' consecutive months.']};
                        }
                    }
                }

                if(this.uploads.length === 0 && this.received_ami_subsidy == 1 && this.ami_subsidy_adjusted == 1 && this.programSettings['requires-interim-certificate'])
                {
                    this.errors.renterDocs = { errors: ['You must provide renter document.']}
                }

                for(var i in this.assets.unitLedgerEntryTypes) {
                    let type = this.assets.unitLedgerEntryTypes[i];
                    let component = this.$refs['assistance_'+type.id][0];
                    let errors = await component.validate();
                    if(_.size(errors)) {
                        this.errors = _.merge(this.errors, errors);
                    }
                }

                if(_.size(this.errors) > 0) return false;


                // Server Validation
                let r = await this.save();
                try {
                    this.$store.dispatch('Application/fetch', this.application.id);
                    this.$store
                        .dispatch('Application/fetchVendorList', this.application.id)
                    // Success
                    return true;
                }catch(err) {
                    this.errors = err.response.data.errors;
                    return false;
                }
            },
            save() {
                let data = {};

                if(this.application.home_owner) {
                    let mortgageAmount = (this.owner.mortgageCurrent) ? this.owner.unpaidPrincipalAmount : this.owner.delinquentAmount;

                    data['has_first_lien'] = this.owner.liens.first;
                    data['has_second_lien'] = this.owner.liens.second;
                    data['has_additional_lien'] = this.owner.liens.additional;
                    data['mortgage_current'] = this.owner.mortgageCurrent;
                    data['mortgage_unpaid_principal_amount'] = this.owner.unpaidPrincipalAmount;
                    data['mortgage_delinquent_amount'] = this.owner.delinquentAmount;
                    data['escrow_value'] = this.owner.escrowed;
                    data['hoa_value'] = this.owner.hoa;
                    data['mortgage_servicer'] = this.application.mortgage_servicer;
                    data['mortgage_account_number'] = this.owner.mortgageAccountNumber;
                    data['requested_mortgage_amount'] = mortgageAmount;
                    data['service_name'] = this.application.service_name;
                }
                if(this.application.renter) {
                    data['manager_company_name'] = this.application.manager_company_name;
                    data['owner_company_name'] = this.application.owner_company_name;
                    data['documents'] = this.uploads;

                }

                data['received_ami_subsidy'] = this.application.received_ami_subsidy;
                data['ami_subsidy_adjusted'] = this.application.ami_subsidy_adjusted;
                data['applicant_disconnect_status_id'] = this.application.applicant_disconnect_status_id;
                data['applicant_eviction_status_id'] = this.application.applicant_eviction_status_id;
                data['federal_program_assistance_id'] = this.application.federal_program_assistance_id;
                data['federal_program_assistance_other'] = this.application.federal_program_assistance_other;
                data['bedroom_count'] = this.application.bedroom_count;
                data['rent_amount'] = this.application.rent_amount;
                data['related_to_landlord'] = this.application.related_to_landlord;

                let ule = [];
                _.each(this.assets.unitLedgerEntryTypes, type => {
                    let component = this.$refs['assistance_'+type.id][0];
                    let inputs = component.getMonthInputs();
                    _.each(inputs, (amounts, monthString) => {
                        ule.push({
                            unit_ledger_entry_type_id: type.id,
                            due_date: moment(monthString+'-01').format('YYYY-MM-DD'),
                            amount_due: amounts.amount,
                            fees_due: amounts.fees,
                            amount_paid: amounts.paid,
                            application_id: this.application.id,
                            household_member_id: component.getHouseholdMemberId(),
                            disconnect_status_id: component.getDisconnectStatusId(),
                            alternative_funding_programs: amounts.alternative_funding_programs,
                            account_number: component.getAccountNumber(),
                            vendor_organization_id: component.getVendorId(),
                            vendor_organization_name: component.getVendorName(),
                            amount_approved: amounts.approved,
                            paid_by_sponsor: amounts.paid_by_sponsor,
                            has_payment: amounts.has_payment ? 1 : 0,
                        })
                    })
                });
                data['unit_ledger_entries'] = ule;
                data['receiving_other_assistance'] = this.application.receiving_other_assistance;

                return axios.put(`/api/hope/applications/${this.application.id}/step-2`, data)
            },

            getTotalRequested() {
                let total = 0;

                _.each(this.assets.unitLedgerEntryTypes, type => {
                    let component = this.$refs['assistance_'+type.id];

                    if(!type.is_utility) {
                        // Check AMI
                        if(this.application.ami_subsidy_adjusted === 0) {
                            return;
                        }
                    }

                    if(component) {
                        let inputs = component[0].getMonthInputs();
                        _.each(inputs, (amounts, monthString) => {
                            let monthDue = amounts.amount + amounts.fees - amounts.paid;

                            if(amounts.alternative_funding_programs && amounts.alternative_funding_programs.length) {
                                _.each(amounts.alternative_funding_programs, afp => {
                                    monthDue -= afp.pivot.amount;
                                })
                            }

                            total += monthDue;
                        })
                    }

                });

                return total;
            },

            getTotalApproved() {
                let total = 0;

                _.each(this.assets.unitLedgerEntryTypes, type => {
                    let component = this.$refs['assistance_'+type.id];

                    if(component) {
                        let inputs = component[0].getMonthInputs();
                        _.each(inputs, (amounts, monthString) => {
                            if(amounts.approved) {
                                let monthDue = amounts.approved;
                                total += monthDue;
                            }

                        })
                    }

                });

                return total;
            },
            getTotalPaid() {
                let total = 0;

                _.each(this.assets.unitLedgerEntryTypes, type => {
                    let component = this.$refs['assistance_'+type.id];

                    if(!type.is_utility) {
                        // Check AMI
                        if(this.application.ami_subsidy_adjusted === 0) {
                            return;
                        }
                    }

                    if(component) {
                        let inputs = component[0].getMonthInputs();
                        _.each(inputs, (amounts, monthString) => {
                            let monthDue = amounts.paid_by_sponsor;

                            total += monthDue;
                        })
                    }

                });

                return total;
            },

            validate() {
                return true;
            },

            onCurrentMortgageChanged($event) {
                if($event.checked) {this.owner.delinquentAmount = 0;}
            },
        }
    }
</script>
